import { FC } from 'react';
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  TransitionChild,
} from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import Sidebar from './Sidebar';

interface MobileSidebarProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

const MobileSidebar: FC<MobileSidebarProps> = ({
  sidebarOpen,
  setSidebarOpen,
}) => {
  return (
    <Dialog
      open={sidebarOpen}
      onClose={setSidebarOpen}
      className='relative z-50 lg:hidden'
    >
      <DialogBackdrop className='fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear' />

      <div className='fixed inset-0 flex'>
        <DialogPanel className='relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-[closed]:-translate-x-full'>
          <TransitionChild>
            <div className='absolute left-full top-0 flex w-16 justify-center pt-5 duration-300 ease-in-out'>
              <button
                type='button'
                onClick={() => setSidebarOpen(false)}
                className='-m-2.5 p-2.5'
              >
                <span className='sr-only'>Close sidebar</span>
                <XMarkIcon aria-hidden='true' className='size-6 text-white' />
              </button>
            </div>
          </TransitionChild>

          {/* Sidebar component */}
          <Sidebar />
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default MobileSidebar;
